import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import UpdatePaymentProfileForm from '../../components/UpdatePaymentProfileForm';
import UpdatePaymentProfileECheckForm from '../../components/UpdatePaymentProfileECheckForm';

class UpdatePaymentProfile extends Component {
  state = {
    success: undefined,
  };

  handleSubmit = (values) => {
    const { updatePaymentProfile, userId } = this.props;

    return updatePaymentProfile(userId, values).then(() => {
      this.setState({
        success: 'Successfully updated',
      });
    });
  };

  render() {
    const { user, userId, paymentMethods, card_id, isECheck } = this.props;
    const { success } = this.state;

    const filteredPaymentMethods = paymentMethods.filter((method) =>
      isECheck ? method.echeck_type : !method.echeck_type,
    );
    const selectedCard = card_id
      ? filteredPaymentMethods.find((card) => card.id === card_id)
      : filteredPaymentMethods.find((card) => card.is_default === true);

    const { id, ...values } = selectedCard || {};
    const isDefault = values.is_default;

    const UpdatePaymentForm = isECheck
      ? UpdatePaymentProfileECheckForm
      : UpdatePaymentProfileForm;

    if (!user) {
      return <div>Loading...</div>;
    }
    return (
      <React.Fragment>
        <h1>Update Payment Profile</h1>
        <p className="links">
          <Link className="mb-4" to={`/users/${userId}/payment-methods`}>
            &larr; Back to Payment Methods
          </Link>
        </p>
        <UpdatePaymentForm
          initialValues={{ card_id: id, ...values }}
          paymentMethods={filteredPaymentMethods}
          onSubmit={this.handleSubmit}
          successMsg={success}
          isDefault={isDefault}
        />
      </React.Fragment>
    );
  }
}

export default UpdatePaymentProfile;
